module.exports = __webpack_public_path__ + "static/media/Residential_04.a526c565.jpg";